var _MemoServiceInit_memos, _MemoServiceInit_currentMemo, _MemoServiceInit_loader;
import { __classPrivateFieldGet } from "tslib";
import axios from 'axios';
import { writable } from 'svelte/store';
import { VegaMemoLoader } from '../model/memo/loader/VegaMemoLoader';
import { SessionService } from './SessionService';
class MemoServiceInit {
    constructor() {
        _MemoServiceInit_memos.set(this, writable([]));
        _MemoServiceInit_currentMemo.set(this, writable(null));
        _MemoServiceInit_loader.set(this, new VegaMemoLoader());
    }
    get memos() {
        return __classPrivateFieldGet(this, _MemoServiceInit_memos, "f");
    }
    get currentMemo() {
        return __classPrivateFieldGet(this, _MemoServiceInit_currentMemo, "f");
    }
    setCurrentMemo(memo) {
        __classPrivateFieldGet(this, _MemoServiceInit_currentMemo, "f").set(memo);
    }
    async uploadMemo(memo) {
        const url = 'https://mycast.xyz:9011/memo';
        const form = {
            userKey: SessionService.getPrivateKey(),
            text: memo,
        };
        await axios.post(url, form);
        this.refresh();
    }
    async shareMemo(memoHash) {
        const url = 'https://mycast.xyz:8002/memo';
        const privKey = SessionService.getPrivateKey();
        await axios.post(url, {
            user: privKey,
            memoIdx: Number(memoHash),
        });
    }
    async refresh() {
        __classPrivateFieldGet(this, _MemoServiceInit_memos, "f").set(await __classPrivateFieldGet(this, _MemoServiceInit_loader, "f").load());
    }
}
_MemoServiceInit_memos = new WeakMap(), _MemoServiceInit_currentMemo = new WeakMap(), _MemoServiceInit_loader = new WeakMap();
export const MemoService = new MemoServiceInit();
